import request from "../../../../../../Services/API/Requests";
import {set} from 'object-path-immutable'
export const saveImages = async (images, screenValues) => {
    let newScreenValues = screenValues;
    for(let image of images) {
        try {
            let upload = await request({
                url: "/files/create",
                method: "POST",
                data: deleteProperty(image, 'path')
            });
            newScreenValues = set(screenValues, `${image.path}`, upload.url)
        } catch (e) {
            console.log(e)
        }
    }

    return newScreenValues;
};

const deleteProperty = ({[key]: _, ...newObj}, key) => newObj;